import * as classnames from "classnames";
import { isEqual } from "lodash";
import * as React from "react";

import { Modal, Msg } from "@shared/components";
import ApplicantChallengeModel from "@shared/models/ApplicantChallenge.model";
import { ChallengeStyle } from "@shared/services/enums";

const imageSrc = require("../../../../assets/images/not_allowed.png");

/**
 * Prop interface
 */
export interface FinalChallengeSubmitProps {
  isOpen: boolean;
  challenge?: ApplicantChallengeModel;
  onClose: () => void;
}

/**
 * Page component
 */
class FinalChallengeSubmit extends React.Component<FinalChallengeSubmitProps> {
  constructor(props: FinalChallengeSubmitProps) {
    super(props);
  }

  public shouldComponentUpdate(nextProps: FinalChallengeSubmitProps) {
    return !isEqual(nextProps, this.props);
  }

  public render() {
    const rootStyle = classnames("code-final-challenge-submit");

    const { isOpen, onClose, challenge } = this.props;

    let okButtonLabel = <Msg id="button.backToChallengeList" />;
    let modalContent = <Msg id={"final-challenge-submit.expired.text"} />;

    if (challenge && ChallengeStyle.hasAppealComment(challenge.style)) {
      okButtonLabel = <Msg id="submit-challenge.submitted.button" />;

      modalContent = <Msg id={"final-challenge-submit.expired.text"} />;
    }

    return (
      <Modal
        className={rootStyle}
        isOpen={isOpen}
        onClose={onClose}
        hasCancelButton={false}
        onClickOk={onClose}
        okButtonLabel={okButtonLabel}
        okButtonType="default"
        ariaLabel="Submit Challenge Complete"
      >
        <img src={imageSrc} className="code-final-challenge-submit__img" />
        <p className="code-final-challenge-submit__title">
          <Msg id={"final-challenge-submit.title"} />
        </p>

        <p className="code-final-challenge-submit__body">{modalContent}</p>
      </Modal>
    );
  }
}

export default FinalChallengeSubmit;
